import { Typography } from '@mui/material';
import { bindActionCreators } from '@reduxjs/toolkit';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { VideoRecorderIcon } from 'assets/svg';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { callSelector } from 'features/call/call-base/store/selectors';
import { CallReceivedBaseContainer } from 'features/call/call-received/components';
import {
  coldHandoffRequestingUserNameSelector,
  takeColdHandoffRequest,
} from 'features/cold-handoff/store';
import { getGenderText } from 'features/collaboration-base/helpers';
import { handleError as handleErrorThunk } from 'features/notification/store';
import { declineTeamingRequest } from 'features/teaming/teaming-base/store';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const ColdHandoffCallReceived: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'coldHandoff' });
  const { t: ct } = useTranslation();
  const { languageCode, genderRequest } = useAppSelector(callSelector);
  const requestingUserName = useAppSelector(
    coldHandoffRequestingUserNameSelector
  );
  const dispatch = useAppDispatch();

  const { handleError } = bindActionCreators(
    {
      handleError: handleErrorThunk,
    },
    dispatch
  );

  const handleTakeCall = () => {
    dispatch(takeColdHandoffRequest());
  };

  const handleDeclineCall = () => {
    dispatch(declineTeamingRequest());
  };

  return (
    <CallReceivedBaseContainer
      handleErrorDispatch={handleError}
      primaryButtonOnClick={handleTakeCall}
      secondaryButtonOnClick={handleDeclineCall}
      secondaryButtonText='declineCall'
    >
      <Icon />
      <Typography
        variant='h1'
        align='center'
        color={theme.palette.common.white}
        mt={15}
      >
        {t('callReceivedTitle', {
          userName: requestingUserName,
        })}
      </Typography>
      <Typography variant='body1' color={theme.palette.grey[50]} mt={8}>
        {languageCode}
      </Typography>
      <Typography variant='body1' color={theme.palette.grey[50]} mt={8}>
        {ct('genderPreference')} {getGenderText(genderRequest!)}
      </Typography>
    </CallReceivedBaseContainer>
  );
};

const Icon = styled(VideoRecorderIcon)`
  margin-top: ${theme.spacing(7)};
`;
